import { DesktopDatePicker } from "@mui/x-date-pickers/DesktopDatePicker";
import dayjs from "dayjs";
import FieldLabel from "../FieldLabel/FieldLabel";
import "./DateInput.scss";

// Patient API sends/expects dateOfBirth as DD-MM-YYYY (see usePatientForm's
// formatDate). MUI's DatePicker supports both picking from the calendar and
// typing the date directly in this same format.
const DATE_FORMAT = "DD-MM-YYYY";

const DateInput = ({ title, name, value, onChange, placeholder, disabled, error, helperText }) => {
  const parsedValue = value ? dayjs(value, DATE_FORMAT) : null;

  const handleChange = (date) => {
    onChange({
      target: {
        name,
        value: date && date.isValid() ? date.format(DATE_FORMAT) : "",
      },
    });
  };

  return (
    <div className="date-input">
      {title && <FieldLabel htmlFor={name}>{title}</FieldLabel>}
      <DesktopDatePicker
        value={parsedValue && parsedValue.isValid() ? parsedValue : null}
        onChange={handleChange}
        format={DATE_FORMAT}
        disabled={disabled}
        disableFuture
        slotProps={{
          textField: {
            id: name,
            name,
            fullWidth: true,
            placeholder,
            autoComplete: "off",
            error: error,
            helperText: helperText,
          },
        }}
      />
    </div>
  );
};

export default DateInput;
